@if (!isForNewContracts) {
  <h1 mat-dialog-title class="p-2 text-center">Recherche de clients</h1>
}
@if (isForNewContracts) {
  <h1 mat-dialog-title class="p-2 text-center">Recherche de contracts pour le client {{Client.Name}}</h1>
}
<div mat-dialog-content class="p-3">
  @if (!isForNewContracts) {
    <div class="row">
      <mat-form-field class="col-6 mb-3">
        <input matInput [(ngModel)]="searchText" placeholder="Code ou Nom de client" (keyup.enter)="searchNewClient()">
      </mat-form-field>
      <button appPreventDoubleClick class="col-auto" color="primary" mat-mini-fab (throttledClick)="searchNewClient()">
        <mat-icon class="material-symbols-outlined"> search </mat-icon>
      </button>
    </div>
  }

  @if (!isForNewContracts && AvailableClientList.length >= 1) {
    <mat-selection-list (selectionChange)="setSelectedClients($event)">
      <h3 matSubheader>Clients</h3>
      @for (c of AvailableClientList; track c) {
        <mat-list-option [value]="c">
          <mat-icon class="material-symbols-outlined" mat-list-icon>face</mat-icon>
          {{c.Code}} {{c.Name}}
          <mat-divider></mat-divider>
        </mat-list-option>
      }
    </mat-selection-list>
  }

  @if (isForNewContracts && AvailableContractList.length >= 1) {
    <mat-selection-list (selectionChange)="setSelectedContracts($event)" >
      <h3 matSubheader>Contrats</h3>
      @for (cc of AvailableContractList; track cc) {
        <mat-list-option matLine [value]="cc">
          <mat-icon class="material-symbols-outlined" mat-list-icon>face</mat-icon>
          {{cc.Code}} {{cc.Name}}
          <mat-divider></mat-divider>
        </mat-list-option>
      }
    </mat-selection-list>
  }
  @if (isForNewContracts && AvailableContractList.length === 0) {
    <div class="d-flex justify-content-center" >
      Tous les contracts sont déja assignés à cet utilisateur
    </div>
  }
  <div class="row mt-3 g-0">
    <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
      Annuler
    </button>
    <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanAdd()">
      Ajouter
    </button>
  </div>
</div>